class Optional {

  constructor(value) {

    this._value = value instanceof Optional ? value.getOrUndefined() : value;
  }

  /**
   *
   * @param value
   * @returns {Optional}
   */
  static of(value) {

    return new Optional(value);
  }

  getOrUndefined() {
    return this._value;
  }

  isPresent() {
    return typeof this._value !== 'undefined';
  }

  /**
   *
   * @param func A function to apply to the underlying value if present
   * @returns {Optional}
   */
  map(func) {
    return this.isPresent() ? Optional.of(func(this._value)) : this;
  }

  orElse(alternative) {
    return this.isPresent() ? this._value : alternative;
  }
}

export {Optional};
